<template>
	<div class="view">
		<div class="back" @click="GoBack">
			<i class="el-icon-arrow-left"></i>
		</div>
		<div class="content">
			<div class="bt">
				<div class="title">{{ Title }}</div>
				<!-- <div class="desc">型号：KF-25GW/PBCA-R5</div> -->
			</div>
			<div class="pdf" v-if="IsPDF">
				<div class="iframe">
					<iframe
						:src="ProductInfo[0]"
						ref="bdIframe"
						frameborder="0"
						scrolling="yes"
						marginheight="0"
						marginwidth="0"
					>
					</iframe>
				</div>
			</div>
			<div class="video" v-if="IsVideo">
				<div class="lsit">
					<div
						class="item"
						v-for="(item, index) in ProductInfo"
						:key="index"
					>
						<video
							style="display: block; margin-left: auto; margin-right: auto"
							controls="controls"
							poster="../assets/background.jpeg"
							width="100%"
							data-mce-fragment="1"
						>
							<source :src="item.url" type="video/mp4" />
							{{ $t("noVideo") }}
						</video>
						<span class="btbj">
							<!-- <span>标题</span> -->
							<span>{{ item.name }}</span>
						</span>
						<!-- 产品介绍宣传视频 -->
					</div>
				</div>
				<div class="vidioFooter">{{ $t("noMore") }}</div>
			</div>
		</div>
		<!-- <canvas id="drawing" width="200" height="200"></canvas> -->
		<div class="nodata" v-if="IsNoShow">
			<img src="@/assets/nodata.png" />
			<span>{{ $t("abnormal") }}</span>
		</div>
	</div>
</template>

<script>
import "@/utils/flexible.js";
import { GetProductIntroduceContentOut } from "@/api/qrcode";
export default {
	name: "ProductManual",
	data() {
		return {
			Code: "",
			IsShow: false,
			IsNoShow: false,
			loading: false,
			Background: "rgba(0, 0, 0, 0.9)",
			LoadingIcon: "el-icon-loading",
			scr: "http://localhost:9004/pdfjs/web/viewer.html?file=",
			IsPDF: false,
			IsVideo: true,
			Title: "",
			ProductInfo: [],
		};
	},
	created() {
		const queryUrl = this.getRequest();
		this.Title = queryUrl.name;
		this.GetDetail(queryUrl.QRCodeIntroduceId);
		// if (queryUrl.name == "undefined" || queryUrl.name == undefined) {
		//   this.Title = "暂无"
		// } else {
		//   this.Title = queryUrl.name
		// }
	},
	mounted() {},
	methods: {
		//返回
		GoBack() {
			this.$router.back();
		},
		getRequest() {
			var url = decodeURIComponent(location.search);
			var theRequest = new Object();
			if (url.indexOf("?") != -1) {
				var str = url.substr(1);
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = unescape(
						strs[i].split("=")[1]
					);
				}
			}
			return theRequest;
		},
		//详情
		async GetDetail(id) {
			const { Data } = await GetProductIntroduceContentOut(id);
			if (Data) {
				if (Data.IntroduceType == 1) {
					this.IsPDF = true;
					this.IsVideo = false;
					if (Data.Urls.length >= 1)
						this.ProductInfo.push(
							"pdfjs/web/viewer.html?file=" + Data.Urls[0]
						);
				} else {
					this.IsPDF = false;
					this.IsVideo = true;
					if (Data.Urls) {
						var jsons = JSON.parse(Data.Files);
						jsons = jsons.map((e) => ({
							url: e.url,
							name: e.name.split(".")[0],
						}));

						// const videos = document.querySelectorAll("video");
						// videos.forEach((item) => {
						//   this.videoCover(item, item.firstChild.src);
						//   //参数item为video元素, item.firstChild.src为视频src地址
						// });

						this.ProductInfo = jsons;
					}
				}
			}
		},
		// videoCover(item, url) {
		//   const video = item; // 获取视频对象
		//   let canvas = document.createElement("canvas"); //创建canvas
		//   video.src = url; // video的url地址
		//   const ctx = canvas.getContext("2d"); // 绘制2d
		//   video.crossOrigin = "anonymous"; // 解决跨域问题
		//   video.currentTime = 1; // 视频第一帧
		//   video.oncanplay = () => {
		//     canvas.width = video.clientWidth; // 视频宽度
		//     canvas.height = video.clientHeight; //视频高度
		//     // 利用canvas对象方法绘图
		//     ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
		//   };
		// },
	},
};
</script>

<!-- <style lang="scss">
#mainContainer .toolbar{
  display: none !important;
}
#mainContainer{
      background: #fff;
}
</style> -->

<style scoped lang="scss">
::v-deep .el-icon-loading {
	font-size: 00.5rem;
}
.view {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-content: center;
	background: #ffffff;
	// background-image: url("~@/assets/bj.png");
	background-position: center;
	background-size: cover;
	background-color: #fff;
	.back {
		font-size: 0.6rem;
		position: absolute;
		top: 0;
		left: 0;
		padding: 0.3rem;
	}
	.content {
		.bt {
			display: flex;
			flex-direction: column;
			.title {
				font-size: 0.5rem;
				text-align: center;
				margin: 0.3rem 0 0 0;
				// font-weight: 600;
				letter-spacing: 0.05rem;
			}
			.desc {
				font-size: 0.3rem;
				text-align: center;
				margin: 0.3rem 0 0 0;
			}
		}
		.pdf {
			width: 98vw;
			height: 85vh;
			margin: auto;
			margin-top: 0.3rem;
			.iframe {
				width: 100%;
				iframe {
					width: 100%;
					height: 85vh;
				}
			}
		}
		.video {
			width: 98vw;
			margin: auto;
			margin-top: 0.3rem;
			.lsit {
				display: flex;
				flex-direction: column;
				.item {
					// border: 1px solid #000;
					display: flex;
					flex-direction: column;
					margin: 0 0 0.5rem 0;
					video {
					}
					.btbj {
						background-image: url("~@/assets/btbj.png");
						background-position: center;
						background-size: cover;
						font-size: 0.35rem;
						color: #ffffff;
						text-align: center;
						padding: 0.2rem 0 0.2rem 0;
						letter-spacing: 0.05rem;
						background: #1f1b1a;
						// opacity: 0.5;
						display: flex;
						justify-content: center;
					}
				}
			}
			.vidioFooter {
				font-size: 0.35rem;
				font-weight: bold;
				display: flex;
				justify-content: center;
				width: 100%;
				height: 0.35rem;
				padding-bottom: 0.8rem;
			}
		}
	}

	.nodata {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		img {
			width: 80%;
		}
		span {
			font-size: 0.45rem;
		}
	}
}
</style>
